const LANGUAGE = {
  COPY_BE_KIND: "Kia atawhai",
  COPY_VERSION: "Putanga",
  COPY_SETTINGS_FREQUENTLY_ASKED_QUESTIONS: "Pātai Auau",
  COPY_SETTINGS_LANGUAGE: "Reo",
  COPY_HOME_ADD_A_NEW_ORGANISATION: "Tāpirihia he whakahaere hou",
};

export default LANGUAGE;
